import $ from 'jquery';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import URLQueryBuilder from 'url-query-builder';

import './c-filter.scss';
import QdGoogleAutocomplete from '../google-autocomplete/google-autocomplete.js';
import { i18n } from '../../translation.js';
import template from './filter.vhtml';

export default {
	components: {
		VueGoogleAutocomplete,
		QdGoogleAutocomplete,
	},
	template,
	props: {
		filterSetup: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			displayedFilters: [],
			selected: '',
			selections: {},
			isOpen: false,
			searchStr: '',
			placeholder: i18n.t( 'search' ) + '...',
			address: null,
			urlParameters: [],
		};
	},
	watch: {
		searchStr() {
			this.selectOption( 'search_str', this.searchStr );
		},
		address() {
			if (this.address !== null) {
				const lat = this.address.latitude == '57.81268979999999' ? '55.604981': this.address.latitude;
				const lng = this.address.longitude == '16.692752499999983' ? '13.003822000000014': this.address.longitude;
				const latLng = lat + '/' + lng;
				this.selectOption('lat_lng', latLng);
			} else {
				this.selectOption('lat_lng', null);
			}
		},
	},
	methods: {
		selectOption( name, value ) {
			let newValues = {};
			newValues[ name ] = value;
			this.selections = Object.assign({}, this.selections,  newValues );
			if ( name === 'product_lines_picker_id' ) {
				this.updateUrl( name, value );
			}
			this.update( this.selections );
		},
		showMore() {
			if ( this.isOpen ) {
				$( '.c-filter__more-filters.js-slide-down-up' ).slideUp( 400 );
				this.isOpen = false;
			} else {
				$( '.c-filter__more-filters.js-slide-down-up' ).slideDown( 400 );
				this.isOpen = true;
			}
			
		},
		update( value ) {
			this.$emit( 'update-filters', value );
		},
		/**
		 * When the location found
		 * @param {Object} addressData Data of the found location
		 * @param {Object} placeResultData PlaceResult object
		 * @param {String} id Input container ID
		 */
		getAddressData: function (addressData) {
			this.address = addressData;
		},
		getAddress: function (addressData) {
			this.address = addressData;
		},
		clear() {
			this.address = null;
		},
		updateUrl( name, value ) {
			const urlParams = Object.assign({}, { product_line: value });
			const q = new URLQueryBuilder(document.location.href, urlParams);

			if( value.length === 0 || value === null ) {
				q.delete( 'product_line' );
			}
			window.history.replaceState(null, null, q.getUrl());
		},
	},
	mounted() {
		this.displayedFilters = Array.prototype.slice.call( this.filterSetup.filters, 0,  this.filterSetup.display );
		this.filterSetup.filters.forEach( function( el ) {
			if ( 'value' in el ) {
				this.selectOption( el.name, el.value );
			}
		}, this );
		this.urlParameters = getAllUrlParams();
		
		if (this.urlParameters.hasOwnProperty( 'product_line' ) ) {
			this.selected = this.urlParameters.product_line;
			this.selectOption( 'product_lines_picker_id', this.urlParameters.product_line );
		}
	},
};

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars() {
	let vars = [], hash;
	const hashes = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&');
	for (let i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		vars.push(hash[0]);
		vars[hash[0]] = hash[1];
	}
	return vars;
}

function getAllUrlParams(url) {

  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

  // we'll store the parameters here
  var obj = {};

  // if query string exists
  if (queryString) {

    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0];

    // split our query string into its component parts
    var arr = queryString.split('&');

    for (var i=0; i<arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('=');

      // in case params look like: list[]=thing1&list[]=thing2
      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function(v) {
        paramNum = v.slice(1,-1);
        return '';
      });

      // set parameter value (use 'true' if empty)
      var paramValue = typeof(a[1])==='undefined' ? true : a[1];

      // (optional) keep case consistent
      paramName = paramName.toLowerCase();
      paramValue = paramValue.toLowerCase();

      // if parameter name already exists
      if (obj[paramName]) {
        // convert value to array (if still string)
        if (typeof obj[paramName] === 'string') {
          obj[paramName] = [obj[paramName]];
        }
        // if no array index number specified...
        if (typeof paramNum === 'undefined') {
          // put the value on the end of the array
          obj[paramName].push(paramValue);
        }
        // if array index number specified...
        else {
          // put the value at that index number
          obj[paramName][paramNum] = paramValue;
        }
      }
      // if param name doesn't exist yet, set it
      else {
        obj[paramName] = paramValue;
      }
    }
  }

  return obj;
}


// WEBPACK FOOTER //
// ./assets/_js/components/filter/filter.js